/* The Butterfly Effect appear-on-scroll for custom sections.
   Any element with [data-appear] reveals its direct children (fade + rise, staggered)
   when it scrolls into view. Content stays fully visible when JS is off or the user
   prefers reduced motion. Hiding only happens after this script arms it. */
(function () {
  var d = document, root = d.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduce || !('IntersectionObserver' in window)) return;

  root.classList.add('bfe-appear-ready');

  function reveal(el) {
    if (!el || el.classList.contains('is-appeared')) return;
    el.classList.add('is-appeared');
  }

  function arm(scope) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    (scope || d).querySelectorAll('[data-appear]').forEach(function (el) {
      /*
       * The mobile hero uses display: contents so its children can be reordered.
       * That wrapper has no box for IntersectionObserver to measure. Reveal it
       * after the initial hidden state has painted, preserving the animation.
       */
      if (window.getComputedStyle(el).display === 'contents') {
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            reveal(el);
          });
        });
        return;
      }

      io.observe(el);

      /*
       * Mobile Safari can occasionally miss an above-the-fold observation while
       * media and layout are settling. Never leave visible content permanently hidden.
       */
      window.setTimeout(function () {
        if (el.classList.contains('is-appeared')) return;

        var rect = el.getBoundingClientRect();

        if (rect.bottom > 0 && rect.top < window.innerHeight * 1.1) {
          reveal(el);
          io.unobserve(el);
        }
      }, 900);
    });
  }

  function start() {
    arm(d);
  }

  if (d.readyState !== 'loading') {
    start();
  } else {
    d.addEventListener('DOMContentLoaded', start);
  }

  d.addEventListener('shopify:section:load', function (event) {
    arm(event.target || d);
  });
})();